import { useContext } from 'react';
import { Redirect } from 'react-router';
import { AuthenticationContext } from '../msal/AuthenticationContext';
import { urls } from '../logic/urls';
import { LoginScreen } from '../components/LoginScreen';

export const Home = () => {
    const authenticationInfo = useContext(AuthenticationContext);

    if (authenticationInfo.isAuthenticated() && authenticationInfo.isAuthorized()) {
        return <Redirect to={urls.license}/>
    }

    return (
        <LoginScreen/>
    );
};